import { injectable, inject } from 'inversify';
import type { CreateTenantResult, ITenantRepository, TenantFormData } from '@/domain/repositories/ITenantRepository';
import { TYPES } from '@/di/tokens';

@injectable()
export class CreateTenantAction {
  constructor(
    @inject(TYPES.ITenantRepository) private tenantRepository: ITenantRepository
  ) {}

  async execute(data: TenantFormData): Promise<CreateTenantResult> {
    return await this.tenantRepository.create(data);
  }
}
